import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'addLinkImage' })
export class AddLinkImagePipe implements PipeTransform {
  transform(html: string): string {
    if (!html) return html;

    const iconTag = "<i aria-hidden='true' class='fas fa-arrow-up-right-from-square fa-2xs'></i>&nbsp;";

    // finds every opening <a> tag and inserts link image immediately inside it
    return html.replace(/<a\b([^>]*)>/gi, `<a$1>${iconTag}`);
  }
}
